import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'

const searchMapsByWorkspaceId = async ({
  workspaceId,
  limit,
  offset,
  tagIds,
  query
}) => {
  const { data, errors } = await API.graphql({
    query: SEACH_MAPS_BY_WORKSPACE_ID_QUERY,
    variables: {
      workspaceId,
      limit,
      offset,
      tagIds,
      query
    }
  })

  if (errors) throw errors

  return data.searchMaps
}

const SEACH_MAPS_BY_WORKSPACE_ID_QUERY = gql`
  query SearchMapsByWorkspaceId(
    $workspaceId: ID!
    $limit: Int!
    $offset: Int
    $tagIds: [String!]
    $query: String
  ) {
    searchMaps(
      workspaceId: $workspaceId
      from: $offset
      size: $limit
      tagIds: $tagIds
      query: $query
    ) {
      items {
        id
        createdAt
        name
        description
        dataId
        views
        properties {
          name
          type
          visualisation
          isAggregate
          isPercentage
          isDefaultVisualisation
          isTitle
        }
        creator {
          id
          firstName
          lastName
          avatar
        }
        mapTagCollection {
          total
          items {
            tag {
              id
              name
              description
              type
              count
            }
          }
        }
      }
      total
    }
  }
`

export {
  searchMapsByWorkspaceId,
  SEACH_MAPS_BY_WORKSPACE_ID_QUERY as GET_MAPS_BY_WORKSPACE_ID_QUERY
}
export default searchMapsByWorkspaceId
